import { mergeTranslations } from 'react-admin';
import raMessages from 'ra-language-english';
const apiHubMessages = {
    ra: Object.assign(Object.assign({}, raMessages), { page: {
            dashboard: 'Accueil',
        }, action: {
            add_filter: 'Ajouter un filtre',
            show: 'Spectacle',
            edit: 'Éditer',
            bulk_actions: '1 élément sélectionné |||| %{smart_count} articles sélectionnés',
            loading: 'Chargement...',
        }, actions: Object.assign(Object.assign({}, raMessages.actions), { open_sidebar: 'Ouvrir le menu', close_sidebar: 'Fermer le menu' }), navigation: Object.assign(Object.assign({}, raMessages.navigation), { page_rows_per_page: 'Eléments par page :', next: 'Proc', prev: 'Préc' }), auth: {
            logout: 'Se déconnecter',
        } }),
    apihub: {
        login: {
            title: 'Se connecter à API Hub',
            fields: {
                username: "Nom d'utilisateur",
                password: 'Mot de passe',
            },
            actions: {
                sign_in: 'Connexion',
                sign_in_with: 'Connexion avec',
                sign_up_title: "Nouvel utilisateur d'API Hub ?",
                sign_up: 'Créer un compte API Hub',
                forgot_password: 'Mot de passe oublié ?',
            },
            notifications: {
                invalid_credentials: "Informations d'identification non valides. Veuillez réessayer ou utiliser le lien mot de passe oublié ci-dessous",
                selected_scheme: 'Connexion avec',
                local_logins_disabled: 'L’accès direct est interdit. Vous devez sélectionner une méthode d’authentification dans la liste ci-dessous. Vous pouvez contacter votre administrateur pour plus d’informations.',
            },
        },
        account_setup: {
            title: 'Terminer et activer votre compte',
            fields: {
                firstname: 'Prénom',
                lastname: 'Nom',
                email: 'Courriel',
                username: "Nom d'utilisateur",
                password: 'Mot de passe',
                confirm_password: 'Confirmer le mot de passe',
            },
            actions: {
                submit: 'Activer votre compte',
                open_login_page: 'Accéder à la page de connexion',
            },
            validation: {
                error_password_match: 'Les mots de passe sont différents.',
                error_username_not_unique: "Ce nom d'utilisateur n'est pas unique.",
                tooltip_username: '6 caractères minimum\n60 caractères maximum',
                tooltip_password: 'Exigences relatives au mot de passe : \n- 8 caractères minimum\n- 60 caractères maximum\n- Au moins une minuscule\n- Au moins une majuscule\n- Au moins un chiffre\n- Au moins un caractère spécial parmi ceux ci-après : !@#$%^&*',
                tooltip_password_confirm: 'Resaisissez votre mot de passe',
            },
            notifications: {
                prepare: 'Préparation du formulaire..',
                invalid_request: 'Impossible de configurer votre compte.',
                success: 'Votre compte a été configuré.',
            },
            terms_of_use: {
                terms_of_use_acknowledgement: "J’ai lu et j'accepte les ",
                terms_of_use: "Conditions d'utilisation",
                terms_of_use_validation: 'Accepter nos termes et conditions',
                terms_of_use_dialog: {
                    title: "Conditions d'utilisation",
                    close: 'Fermer',
                },
            },
        },
        reset_password: {
            title: 'Réinitialiser le mot de passe',
            fields: {
                username: "Nom d'utilisateur",
            },
            actions: {
                submit: 'Soumettre',
            },
            form_details: {
                instructions: "Entrez votre nom d'utilisateur.",
                description: 'Un lien de réinitialisation de votre mot de passe vous sera envoyé par courriel.',
            },
            notifications: {
                local_logins_disabled: 'Le password ne peut être réinitialisé lorsque l’accès direct est désactivé.',
            },
        },
        reset_password_confirm: {
            title: 'Demande de réinitialisation du mot de passe envoyée',
            actions: {
                open_login_page: 'Accéder à la page de connexion',
            },
            form_details: {
                instructions: 'Consultez votre boîte de réception.',
                description: 'Pour réinitialiser votre mot de passe, cliquez sur le lien inclus dans votre courriel.',
            },
        },
        new_password: {
            title: 'Créer un mot de passe',
            fields: {
                current_password: 'Mot de passe actuel',
                password: 'Mot de passe',
                confirm_password: 'Confirmer le mot de passe',
            },
            actions: {
                change_password: 'Modifier le mot de passe',
                open_login_page: 'Accéder à la page de connexion',
            },
            validation: {
                error_password_match: 'Les mots de passe sont différents.',
                tooltip_password: 'Exigences relatives au mot de passe : \n- 8 caractères minimum\n- 60 caractères maximum\n- Au moins une minuscule\n- Au moins une majuscule\n- Au moins un chiffre\n- Au moins un caractère spécial parmi ceux ci-après : !@#$%^&*',
                tooltip_password_confirm: 'Resaisissez votre mot de passe',
            },
            notifications: {
                confirmation: 'Votre mot de passe a été réinitialisé. Utilisez votre nouveau mot de passe pour vous connecter.',
                verifying_token: 'Vérification de votre demande de réinitialisation du mot de passe...',
                invalid_token: "Impossible de créer un mot de passe : votre jeton n'est pas valide.",
            },
        },
        menu: {
            user_details: {
                full_name: '%{last_name} %{first_name}',
            },
        },
        homepage: {
            placeholder_empty_content: "Le contenu de la page d'accueil n'a pas encore été fourni. Les administrateurs du portail peuvent cliquer sur Créer pour ajouter du contenu.",
        },
        actions: {
            view_as_cards: 'Afficher sous forme de cartes',
            view_as_list: 'Afficher sous forme de liste',
            tree_drop_before: 'Avant %{title}',
            tree_drop_after: 'Après %{title}',
            select_an_api_plan: "Sélectionner un plan d'API (obligatoire)",
        },
        validation: {
            password: {
                at_least_one_lowercase_character: 'Au moins une minuscule',
                at_least_one_uppercase_character: 'Au moins une majuscule',
                at_least_one_number: 'Au moins un chiffre',
                at_least_one_special_character: 'Au moins un caractère spécial parmi ceux ci-après : !@#$%^&*',
                no_other_characters_accepted: 'Seuls les caractères alphanumériques et !@#$%^&*- sont autorisés',
            },
        },
        markdown_editor: {
            fonts: {
                bold: 'Gras',
                italic: 'Italique',
                strikethrough: 'Barré',
                unordered: 'Liste non triée',
                order: 'Liste numérotée',
                quote: 'Citation',
                hr: 'Saut de ligne',
                inlinecode: 'Code intégré',
                code: 'Code de bloc',
            },
        },
        terms_and_conditions: {
            api_label: "En cliquant sur Sélectionner une API, j'accepte les termes et conditions.",
            api_group_label: "En cliquant sur Sélectionner un groupe d'API, j'accepte les termes et conditions.",
        },
    },
    resources: {
        apis: {
            name: 'API |||| API',
            fields: {
                name: 'Nom ',
                portalStatus: 'Etat',
                accessStatus: 'Accès',
                apiServiceType: 'Type',
                ssgServiceType: 'Type',
                createTs: 'Créé',
                modifyTs: 'Modifié',
                version: 'Version',
                versionShort: 'V',
                description: 'Description ',
                privateDescription: 'Description privée',
                tags: 'Etiquettes',
                applicationUsage: 'Applications',
                assets: 'Actifs',
                apiLocation: "Emplacement de l'API",
                apiGroup: "Groupe d'API",
            },
            portalStatus: {
                enabled: 'Activé',
                disabled: 'Désactivé',
                deprecated: 'Désapprouvé',
                unpublished: 'Non publié',
                incomplete: 'Incomplet',
            },
            accessStatus: {
                public: 'Public',
                private: 'Privée',
            },
            last_update: {
                fields: {
                    updated: 'Modification %{date}',
                },
            },
            list: {
                cards: {
                    fields: {
                        updated: 'Modification %{date}',
                        version: 'v%{version}',
                        applications: '%{smart_count} application(s)',
                        applications_long: '1 application utilisant cette API |||| %{smart_count} applications utilisant cette API',
                        averageLatency: '%{ms} ms',
                        averageLatency_long: 'Latence moyenne au cours des 7 derniers jours',
                    },
                },
                sort: {
                    name: {
                        asc: "Nom de l'API : A-Z",
                        desc: "Nom de l'API : Z-A",
                    },
                    createTs: {
                        asc: 'Date de création : du plus ancien au plus ancien récent',
                        desc: 'Date de création : du plus récent au plus ancien',
                    },
                    modifyTs: {
                        asc: 'Date de modification : du plus ancien au plus ancien récent',
                        desc: 'Date de modification : du plus récent au plus ancien',
                    },
                },
                filters: {
                    search: 'Rechercher par nom ou par description',
                },
            },
            overview: {
                title: 'Présentation',
                fields: {
                    version: 'v%{version}',
                },
                actions: {
                    download_assets: 'Télécharger les actifs',
                },
                notifications: {
                    no_assets: "Aucun actif n'est associé à cette API.",
                },
            },
            specification: {
                title: 'Spécifications',
                fields: {
                    select_application_label: 'Applications utilisées',
                },
                actions: {
                    select_application: "Sélectionnez l'application pour utiliser sa clé par défaut.",
                    search_or_select_application: 'Rechercher ou sélectionner une application',
                },
            },
            documentation: {
                title: 'Documentation',
            },
        },
        apiGroups: {
            name: "Groupe d'API |||| Groupes d'API",
            short_name: 'Groupe |||| Groupes',
            fields: {
                name: 'Nom ',
            },
        },
        apiPlans: {
            name: "Plan d'API |||| Plans d'API",
            fields: {
                name: 'Nom ',
                description: 'Description ',
                rate_limit: 'Limite de taux',
                quota: 'Quota',
                quota_interval: 'Intervalle de quota',
                second: 'seconde',
                day: 'jour',
                month: 'mois',
            },
        },
        applications: {
            name: 'Application |||| Applications',
            fields: {
                name: 'Nom ',
                apiKey: "Clé d'API :",
                keySecret: 'Secret partagé :',
                apiKeyClientID: "Clé d'API/ID de client",
                apisIncluded: 'API incluses',
                apis: 'APIs',
                apisCount: '%{count}',
                authentication: 'Authentification',
                description: 'Description ',
                encrypted: 'Chiffré',
                sharedSecretClientSecret: 'Secret partagé/Secret de client',
                oauthType: 'Type OAuth',
                oauthCallbackUrl: 'URL de rappel OAuth',
                oauthScope: 'Etendue OAuth',
                overview: 'Présentation',
                status: 'Etat',
                apiGroups: "Groupes d'API",
                apiGroupsCount: '%{count}',
                apiGroup: "Groupe d'API",
                organization: 'Organisation',
                applicationInformation: "Informations sur l'application",
                customField: 'Champ personnalisé',
                details: 'Détails',
                noCustomFields: "Aucun champ personnalisé n'est disponible.",
                noApplications: "Aucune application n'est disponible",
                apiManagement: 'Gestion des API',
                authCredentials: 'Authentifications et références',
                callbackUrl: 'URL(s) de rappel/redirection',
                scope: 'Portée ',
                type: 'Type',
                secretType: 'Type de secret',
                none: 'Aucun(e)',
                public: 'Public',
                confidential: 'Confidentiel',
                hashed: 'Hashed',
                plain: 'Format texte.',
                sharedSecretFormat: 'Format du secret partagé',
                selectOrganization: "Sélectionner l'organisation",
                apiPlan: "Plan d'API",
                quota: 'Quota',
                rateLimit: 'Limite de taux',
                termsOfUseApi: "En cliquant sur Ajouter une API, j'accepte les termes et conditions.",
                actions: 'Actions',
                default: 'Défaut',
            },
            actions: {
                generateSecret: 'Générer un nouveau secret',
                copyNewSecret: 'Copier le nouveau secret',
                plainTextSecret: 'Secret en texte brut',
                hashedSecret: 'Secret haché',
                cancel: 'Annuler',
                publish: 'Publier',
                save: 'Enregistrer',
                addApplication: 'Ajouter une application',
                createApplication: 'Créer une application',
                deleteApplication: "Supprimer l'application",
                deleting_title: "Suppression de l'application",
                select_api: "Sélectionner l'API",
                addApi: 'Ajouter une API',
                addApiGroup: "Ajouter un groupe d'API",
                searchByApiTitle: 'Rechercher',
                filterByTag: 'Filtrer par étiquette',
                accept_terms_and_conditions: "J'accepte les termes et conditions",
                edit: 'Modifier',
                delete: 'Supprimer',
                force_delete: 'Forcer la suppression',
                no: 'Non',
                yes: 'Oui',
            },
            validation: {
                apikey_name_caption: 'Le nom de la clé doit être unique pour l’application. La longueur maximale est de 255 caractères.',
                error_application_name_not_unique: "Le nom de cette application n'est pas unique.",
                callback_url_caption: 'Utiliser des valeurs séparées par des virgules',
                scope_caption: 'Utiliser des valeurs séparées par des espaces',
                application_name_caption: 'Le nom de la clé doit être unique pour l’application. La longueur maximale est de 255 caractères.',
                apikey_name_caption: 'Le nom de la clé doit être unique pour cette application. La longueur maximale est de 255 caractères.',
                apikey_name_empty_error: 'Le nom ne peut pas être vide',
            },
            status: {
                enabled: 'Activé',
                disabled: 'Désactivé',
                deprecated: 'Désapprouvé',
                delete_failed: 'Echec de la suppression.',
                incomplete: 'Incomplet',
                unpublished: 'Non publié',
                rejected: 'Rejeté',
                application_pending_approval: "En attente d'approbation",
                edit_application_pending_approval: "En attente d'approbation",
                delete_application_pending_approval: "En attente d'approbation",
                apis_help_text: 'Au moins 1 API (ou un groupe d’API) est nécessaire pour publier une application.',
                api_keys_help_text: 'Au moins une clé d’API est nécessaire pour publier une application.',
                partial_lock: 'Des parties de cette section sont verrouillées en attente de la validation d’une modification précédente.',
                complete_lock: 'Cette section est verrouillée en attente de la validation d’une modification précédente.',
                create_apis_help_text: "Enregistrement requis avant de pouvoir ajouter des API. Au moins 1 API (ou groupe d'API) est nécessaire pour publier une application.",
                create_api_keys_help_text: 'Enregistrement requis avant de pouvoir créer des clés. Au moins 1 clé API est requise pour publier une application',
            },
            list: {
                sort: {
                    name: {
                        asc: "Nom de l'application : A-Z",
                        desc: "Nom de l'application : Z-A",
                    },
                },
            },
            notifications: {
                configuration: 'Configuration',
                copy_success: 'Copié dans le presse-papiers',
                copy_error: 'Echec de la copie dans le presse-papiers',
                generate_secret_warning_1: "La génération d'un nouveau secret modifie la clé d'API et annule la clé d'API actuelle.",
                generate_secret_warning_2: "Cette option permet d'empêcher l'accès à quiconque utilise la clé d'API actuelle. Partagez le nouveau secret généré avec les développeurs qui codent une application utilisant les API.",
                secret_generated_heading: 'Nouveau secret généré',
                secret_generated_heading_error: "Une erreur s'est produite lors de la génération du secret.",
                secret_generated_message: "Le secret de texte est visible uniquement pendant la session de navigation actuelle ; il est haché après l'actualisation de la page.",
                copy_secret_now: 'Copier le secret partagé maintenant',
                copy_to_clipboard: 'Copier dans le presse-papiers',
                edit_overview: 'Modifier la présentation',
                empty_overview: 'Aucune valeur',
                create_success: "L'application a été créée.",
                key_create_success: 'Clé d’API créée avec succès.',
                create_error: "Une erreur s'est produite lors de la création de l'application.",
                edit_request_success: 'Demande de mise à jour de l’application effectuée.',
                edit_success: "L'application a été mise à jour.",
                edit_error: "Une erreur s'est produite lors de la mise à jour de l'application.",
                delete_success: "L'application a été supprimée.",
                delete_request_success: 'Demande de suppression de l’application effectuée avec succès.',
                delete_error: "Une erreur s'est produite lors de la suppression de l'application.",
                publish_request_success: 'Demande de publication de l’application effectuée.',
                unsaved_changes: 'Modifications non enregistrées.',
                unsaved_changes_content: 'Cette section contient des modifications qui n’ont pas été enregistrées. Souhaitez-vous toujours quitter cette section ?',
                delete_key_success: "'Clé d'application supprimée avec succès.",
                publish_success: 'Application publiée avec succès.',
            },
            confirm_delete: 'Vous êtes sur le point de supprimer cette application. Voulez-vous continuer ?',
            deleting_content: "Annulation du déploiement des clés et suppression de l'application. Cela peut prendre plusieurs minutes.",
            proxy_check_alert: 'Impossible de se connecter à tous les proxys sur lesquels des clés de l’application ont été déployées. Ceci va probablement résulter en une suppression partielle, où certaines clés vont rester sur certains proxys. Elles devront être supprimées directement à partir du proxy (gateway). Il y aura une option pour supprimer de force l’application à partir du portail.',
            publish_help_text: 'Une application complète avec au moins 1 API et 1 clé peut être publiée et sa clé déployée vers les proxys.',
        },
        apikeys: {
            confirm_delete: 'Vous êtes sur le point de supprimer cette clé d’API. En êtes vous sûr ?',
            deleting_content: 'Suppression du déploiement et de la clé d’API. Ceci peut prendre quelques minutes.',
            proxy_check_alert: 'Impossible de se connecter à tous les proxys où la clé d’API a été déployée. Ceci va probablement résulter en une suppression partielle, où la clé va rester sur certains proxys. La clé devra alors être supprimée directement à partir du proxy (gateway). Il y aura une option pour supprimer de force la clé d’API à partir du portail.',
            actions: {
                addKey: 'Ajouter une clé',
                deleteApiKey: 'Supprimer une clé',
                deleting_title: "Supprimer une clé d'API",
                force_delete: 'Forcer la suppression',
                cancel: 'Annuler',
                delete: 'Supprimer',
            },
        },
        documents: {
            name: 'Wiki |||| Wiki',
            fields: {
                title: 'Titre',
                navtitle: 'URI',
                markdown: 'Contenu',
                modifyTs: 'Dernière modification',
                ordinal: 'Position',
                new_document: 'Nouveau document',
                select_documentation_locale: 'Langue sélectionnée',
            },
            actions: {
                // Toolbar
                new_document_button: 'New root document',
                new_child_document_button: 'Nouvel enfant',
                edit_document_button: 'Modifier',
                delete_document_button: 'Supprimer',
                change_document_parent_button: 'Modifier le parent',
                // Tree
                expand_documentation: 'Expand documentation of node {title}',
                collapse_documentation: 'Réduire la documentation du noeud {title}',
                // Drag & Drop
                move_as_first_child: 'First document',
                move_after_document: 'Après %{title}',
                move_as_root_item: 'Sélectionnez cette option pour accéder à la racine.',
                // Form
                save: 'Publish',
                cancel: 'Annuler',
            },
            validation: {
                error_no_special_characters: "L'URI doit contenir uniquement des caractères non codés. Les lettres de a à z et les séparateurs - et _ sont pris en charge.",
                error_navtitle_not_unique: 'Cet URI existe déjà.',
            },
            notifications: {
                tree_updated_success: "L'arborescence de documentation a été mise à jour.",
                tree_updated_error: "Echec de la mise à jour de l'arborescence de la documentation",
                create_success: 'Le document a été créé.',
                create_error: "Une erreur s'est produite lors de la création du document.",
                edit_success: 'Le document a été mis à jour.',
                edit_error: "Une erreur s'est produite lors de la mise à jour du document.",
                delete_success: 'Le document a été supprimé.',
                delete_error: "Une erreur s'est produite lors de la suppression du document.",
                unsaved_changes: 'Si vous quittez cette page, vos modifications seront perdues. Voulez-vous annuler la modification de ce document ?',
            },
            confirm_delete_document_without_children: 'Vous êtes sur le point de supprimer ce document. Voulez-vous continuer ?',
            confirm_delete_document_with_children: 'Vous êtes sur le point de supprimer ce document et ses documents enfants. Voulez-vous continuer ?',
        },
        registrations: {
            title: 'Créer un compte',
            fields: {
                email: 'Courriel',
                email_confirmation: "Confirmer l'adresse de messagerie",
                organization: 'Organisation ou espace de travail',
                organization_description: "Description de l'organisation",
                robot: "I'm not a robot",
            },
            actions: {
                submit: 'Soumettre',
                login: 'Se connecter à un compte existant',
                return_to_homepage: "Revenir à la page d'accueil",
            },
            notifications: {
                confirmation_required: 'Confirmation requise',
                error: "Un problème est survenu lors de l'enregistrement de votre compte.",
                confirmation_title: 'Consulter votre boîte de réception',
                confirmation: "Enregistrement reçu. Un courriel de notification sera envoyé à l'adresse indiquée.",
                email_confirmation_error: "L'adresse de messagerie ne correspond pas.",
                form_confirmation_error: 'Confirmation requise.',
                limituserregistration: "La demande d'enregistrement de cette adresse électronique est en attente d'approbation/activation. Les demandes multiples ne sont pas autorisées.",
            },
            slider: {
                confirmed: 'Confirmé(e)',
                unconfirmed: 'Faire glisser pour confirmer',
            },
        },
        userContexts: {
            title: 'Mon profil',
            fields: {
                userDetails: {
                    username: "Nom d'utilisateur",
                    lastName: 'Nom',
                    firstName: 'Prénom',
                    email: 'Courriel',
                    password: 'Mot de passe',
                },
                currentPassword: 'Mot de passe actuel',
                newPassword: 'Mot de passe',
                confirmNewPassword: 'Confirmer le mot de passe',
            },
            actions: {
                edit_profile: 'Mon profil',
                cancel: 'Annuler',
            },
            notifications: {
                profile_not_exist_error: "Ce profil n'existe pas.",
                update_success: 'Profil mis à jour',
                update_error: 'La mise à jour du profil a échoué.',
                invalid_password: "Le mot de passe actuel n'est pas valide.",
                confirm_password_change: 'Votre mot de passe a été réinitialisé. Utilisez votre nouveau mot de passe pour vous connecter.',
            },
            validation: {
                error_current_password_empty: 'Saisissez votre mot de passe actuel',
                error_password_match: 'Les mots de passe sont différents.',
                tooltip_password: 'Exigences relatives au mot de passe : \n- 8 caractères minimum\n- 60 caractères maximum\n- Au moins une minuscule\n- Au moins une majuscule\n- Au moins un chiffre\n- Au moins un caractère spécial parmi ceux ci-après : !@#$%^&*',
                tooltip_password_confirm: 'Resaisissez votre mot de passe',
            },
            accessibleOrgs: {
                title: 'Mon organisation |||| Mes organisations',
            },
            activeOrgUuid: {
                status: {
                    active: 'Organisation sélectionnée',
                    not_active: 'Organisation non sélectionnée',
                },
                notifications: {
                    update_success: 'Votre organisation a été mise à jour.',
                    update_error: "La mise à jour de l'organisation a échoué.",
                },
            },
        },
        userProfiles: {
            passwordDialogTitle: 'Entrer le mot de passe actuel',
            fields: {
                userName: "Nom d'utilisateur",
                lastName: 'Nom de famille',
                firstName: 'Prénom',
                email: 'E-mail',
                password: 'mot de passe',
                currentPassword: 'Mot de passe actuel',
                newPassword: 'nouveau mot de passe',
                confirmNewPassword: 'Confirmer le nouveau mot de passe',
            },
            actions: {
                edit_profile: 'Mon profil',
                cancel: 'Annuler',
                submit: 'Soumettre',
            },
            notifications: {
                update_success: 'Profil mis à jour',
            },
            validation: {
                error_password_empty: 'Le mot de passe ne peut pas être vide',
                error_password_match: 'Le mot de passe ne correspond pas',
                error_password_not_matching_criteria: 'Le mot de passe doit répondre aux exigences spécifiées.',
                tooltip_current_password: 'Mot de passe requis pour effectuer des modifications. Veuillez saisir votre mot de passe.',
                tooltip_password_title: 'Exigences relatives au mot de passe:',
                tooltip_password_min: '-Minimum %{num} caractères',
                tooltip_password_max: '-Maximum %{num} caractères',
                tooltip_password_lower: '-Au moins %{num} caractères minuscule)',
                tooltip_password_upper: '-Au moins %{num} caractères majuscule)',
                tooltip_password_number: '-Au moins %{num} nombres)',
                tooltip_password_special: '-Au moins %{num} caractères spéciaux): %{symbols}',
                tooltip_password_confirm: 'Répétez votre mot de passe',
            },
        },
    },
};
export default mergeTranslations(raMessages, apiHubMessages);
//# sourceMappingURL=fr.js.map